import React from 'react';
import { services } from '../../data/services';
import ServiceSection from '../../components/ServiceSection';
import Hero from '../../components/Hero';

const TV = () => {
  const tvService = services.find(service => service.title === "Televiziune");

  return (
    <>
      <Hero
        title="Televiziune Digitală HD"
        subtitle="Peste 200 de canale TV în calitate HD și 4K pentru toată familia"
        variant="compact"
        ctaLabel="Vezi Tarife"
        ctaHref="#tarife"
        backgroundImageUrl="/img/hero-tv.jpg"
        icon={tvService?.icon}
        iconLabel={tvService?.title}
      />

      {tvService && (
        <ServiceSection
          service={tvService}
          index={0}
          pricingFirst
          id="tarife"
          backgroundImage={false}
          showTitleBlock={false}
        />
      )}
    </>
  );
};

export default TV;
